import { z } from 'zod';

export const DoorLockState = z.enum(['locked', 'unlocked', 'forced', 'held', 'unknown']);
export type DoorLockState = z.infer<typeof DoorLockState>;

export const DoorState = z.object({
  vendorDoorId: z.string(),
  lockState: DoorLockState,
  unlockRemainingSeconds: z.number().int().nonnegative().nullable(),
  lastReaderEvent: z
    .object({
      cardNumber: z.string().nullable(),
      grantedOrDenied: z.enum(['granted', 'denied']),
      at: z.iso.datetime(),
    })
    .nullable(),
});
export type DoorState = z.infer<typeof DoorState>;

export const ZoneSnapshotStatus = z.enum([
  'normal',
  'open',
  'short',
  'bypassed',
  'unknown',
]);
export type ZoneSnapshotStatus = z.infer<typeof ZoneSnapshotStatus>;

export const ZoneState = z.object({
  vendorZoneId: z.string(),
  status: ZoneSnapshotStatus,
});
export type ZoneState = z.infer<typeof ZoneState>;

export const PanelStateSnapshot = z.object({
  controllerHealth: z.object({
    firmwareVersion: z.string().nullable(),
    acPowerOk: z.boolean(),
    batteryOk: z.boolean(),
    boxTamperOk: z.boolean(),
    wallTamperOk: z.boolean(),
  }),
  doors: z.array(DoorState),
  zones: z.array(ZoneState),
  capturedAt: z.iso.datetime(),
});
export type PanelStateSnapshot = z.infer<typeof PanelStateSnapshot>;

export const RelaySnapshotPost = z.object({
  controllerId: z.guid(),
  payload: PanelStateSnapshot,
});
export type RelaySnapshotPost = z.infer<typeof RelaySnapshotPost>;
